const OrderType = {
    ALL_ORDERS: 0,
    ALL_SUPPLY_PRODUCT_ORDERS: 1,
    SELF_SALE_PRODUCT_ORDER: 10, // 自己
    CONTRACT_PRODUCT_ORDERS: 11,
    AGENT_SALE_PRODUCT_ORDERS: 12,
    ONLINE_MALL_ORDERS: 20,
    OFFLINE_PAYMENT_ORDERS: 30,
};
export default OrderType;